<template>
  <v-layout
    justify-center
    row
  >
    <v-dialog
      :value="$wait.is('busy')"
      content
      content-class="centered-dialog"
      persistent
    ></v-dialog>
  </v-layout>
</template>

<style>
.dialog.centered-dialog,
.v-dialog.centered-dialog {
  display: none;
}
.v-overlay:before {
  background-color: #eeeeee;
}
</style>

<script>
export default {};
</script>
